<template>
  <div class="height-full">
    <app-header title="Settings"/>
    <b-card no-body>
      <div class="row ">
        
        <div class="col-md-12">

          <b-card style="padding-top: 2%; padding-bottom: 40%">
            <spinner v-if="isLoading"></spinner>
            <div v-if="isLoading == false">
              <h3>Email Notifications</h3>
              <p>ChatRise can send you email notifications when you have new messages available.</p>
              <div>
                <div><br />
                  <h5>Message Notifications</h5><br />
                  <b-form-checkbox 
                    v-model="checked" 
                    name="check-button" 
                    class="check-btn" 
                    switch size="lg"
                    @change="switchChanged"></b-form-checkbox>
                </div>
                <br />
                <div v-if="checked">
                  <h6 class="mb-3">Message notification frequency</h6>
                  <b-form-select 
                    v-model="selected" 
                    :options="options"
                    @change="selectChanged"></b-form-select>
                  <div class="subtitle">
                    <i>ChatRise will only notify you when there's an unread message.</i>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>      
    </b-card>
    <div class="card ">
      <div class="card-body p-0 white slimScroll" data-height="500">
        <div class="row ">
          <div class="col-md-2">
          </div>
          <div class="col-md-8">
            <div>
            </div>

            <div>
            </div>
          </div>
          <div class="col-md-2">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import AmplifyStore from '../store/store'
  import axios from 'axios'
  import Spinner from './common/Spinner'

  import Constants from '../Constants'
  export default {
    name: 'Settings',
    components: {
      Spinner
    },
    data: () => {
      const that = this;
      return {
        isLoading: false,
        options: [
          {value: 'default', text: 'Per Message'}, 
          {value: 'hourly', text: 'Hourly'}, 
          {value: 'four_hours', text: 'Every 4 Hours'}, 
          {value: 'daily', text: 'Daily'}
        ],
        selected: null,
        prefs: '',
        checked: false        
      };
    },
    methods: {
      toggleAccordion: function (el) {
        this[el] = !this[el]
      },
      switchChanged: function(el) {
        console.log(el)
        if (el == true) {
          this.setNotificationPrefs('default')
        } else {
          this.setNotificationPrefs('none')
        }
      },
      selectChanged: function(el) {
        this.prefs = el
        this.setNotificationPrefs(this.prefs)
      },
      setNotificationPrefs: function(prefs) {
        // none, default, hourly, four_hours, Daily
        this.prefs = prefs
        this.updateNotificationPrefs(this.prefs)
      },
      getNotificationPrefs: function() {
        this.isLoading = true
        axios.get(Constants.API_URL + "/me")
          .then((response) => {
            this.prefs = response.data.Items[0].emailNotificationPrefs
            console.log("PREFS:")
            console.log(this.prefs)
            this.checked = this.prefs != 'none'
            this.selected = this.prefs
          }).catch((err) => {
            console.log(err)
          }).then(() => {
            this.isLoading = false
          }) 
      },
      updateNotificationPrefs: function(prefs) {
        this.selected = this.prefs
        axios.put(Constants.API_URL + "/me?emailNotificationPrefs=" + prefs)
          .then((response) => {
            console.log(response)
          })
      }
    },
    mounted() {
      this.getNotificationPrefs()
    }
  }
</script>

<style scoped>
.subtitle {
  margin-top: 8px;
}

.subtitle i {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue